import { createSlice } from "@reduxjs/toolkit";
import { Employee } from "services";

export interface OrgChartReducerState {
  employees: Employee[];
  employeesChecked?: { id: number; orgId: number }[];
}

const initialState: OrgChartReducerState = {
  employees: [],
  employeesChecked: [],
};

export const employeeSlice = createSlice({
  name: "EmployeeReducers",
  initialState,
  reducers: {
    setListEmployees: (state, action) => {
      state.employees = action.payload;
    },
    setEmployeeChecked: (state, action) => {
      state.employeesChecked = action.payload;
    },
    // deleteDept: (state, action: PayloadAction<{ nodeId: number }>) => {
    //   state.orgChart = deleteDept(state.orgChart, action.payload.nodeId);
    // },
    reset: () => initialState,
  },
});
